module.exports = __webpack_public_path__ + "img/Unidad4-2.a22f5e88.png";